import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: end !important;
    gap: 16px;
    margin-top: 24px;

    ${mq.lt.md} {
        flex-direction: column;
        gap: 8px;
        border-top: 1px solid #ececf0;
        padding-top: 24px;

        div {
            display: none;
        }
    }

    ${mq.lt.sm} {
        padding-top: 16px;
    }

    .tooltip-text {
        font-size: 12px;
        line-height: 14px;
        color: #1f2547;
        text-align: center;
        display: none;

        ${mq.lt.md} {
            display: block;
        }
    }

    button {
        padding: 14px 30px;
        color: #1f2547;

        ${mq.lt.md} {
            width: 100%;
        }
    }
`;
